import { all } from "redux-saga/effects";
import otpSaga from "./OtpSaga";
import {addVendorSaga, updateVendorSaga, vendorSaga,vendorUserSaga} from "./VendorSaga";
import { addSubVendorSaga, detailSubVendorSaga, subVendorSaga, updateSubVendorSaga } from "./SubVendorSaga";
import{ addComplianceSaga, addOnBoardComplianceSaga, approveComplianceSaga, complianceSaga, complianceValidationRegexWatcher, configComplianceSaga, onBoardComplianceSaga, updateComplianceSaga } from "./ComplianceSaga";
import { profileSaga, updateProfileSaga } from "./ProfileSaga";
import { addDriverSaga, driverSaga, moreDriverSaga, matrixDriverSaga, ticketDriverSaga, updateDriverSaga } from "./DriverSaga";
import { addFaqSaga, deleteFaqSaga, faqSaga, faqSectionSaga, updateFaqSaga } from "./FAQSaga";
import { addCarSaga, carSaga, deleteCarSaga, facilitiesSaga, updateCarSaga } from "./CarSaga";
import { addTagSaga, ratingSaga, tagSaga, updateTagSaga } from "./TagSaga";
import { userDailyCustomerSaga, userRideAnalyticSaga, userRideDetailsSaga, userTotalRegistrationSaga } from "./DashboardSaga";
import { customerSaga, matrixCustomerSaga, ticketCustomerSaga, updateCustomerSaga } from "./CustomerSaga";
import { customerComplaintsSaga } from "./CustomerComplaintsSaga";
import { addVehicleSaga, deleteVehicleSaga, updateVehicleSaga, vehicleSaga, moreVehicleSaga, matrixVehicleSaga } from "./VehicleSaga";
import { userCabRideSaga, userDashboardFeedbackSaga, userOurCarSaga, userRideAcceptSaga, userTopDriverSaga, userTopSubVendorSaga, userTopVendorSaga } from "./TopSectionSaga";
import { assignDriverSaga, cancelTripSaga, invoiceDownloadSaga, invoiceSaga, sosAlertSaga, tripSaga } from "./TripSaga";
import { notificationCountSaga, notificationSaga, notificationSeenSaga } from "./NotificationSaga";
import { assignVehicleSaga, listAssignedVehicleSaga, requestVehicleSaga, updateAssignDriverSaga, updateAssignSubVendorSaga, updateAssignVehicleSaga } from "./AllotSaga";
import { ChooseYourServiceSaga, addChooseYourServiceSaga, updateChooseYourServiceSaga } from "./ChooseYourServiceSaga";
import { addRateCardSaga, baseFuelSaga, rateCardSaga } from "./RateCardSaga";
import { serviceCitySaga, serviceRegionSaga, addServiceRegionSaga,serviceSubVendorRegionSaga, addSubVendorRegionSaga } from "./ServiceCitySage";
import logoutSaga from "./LogoutSaga";
import { bookingSaga, customerMatrixSaga, revenueExportSaga, revenueMatrixSaga, revenueSaga } from "./ReportSaga";
import { loginSaga, magicTokenSaga, tokenVerifySaga } from "./LoginSaga";
import { getRolesAndPermissionsWatcher, getSupplierRoleWatcher } from "./RolesAndPermissionsSaga";
import { couponSaga,addCouponSaga,updateCouponSaga,deleteCouponSaga } from "./CouponSaga";
import { rideDetailsPolylineSaga } from "./LiveTripSaga";
import { allotVehicleSaga,getAvailablevehicleSaga,getAvailableSupplierSaga } from "./OperationSaga";
import { autoCompleteSaga, directionSaga, geocodeSaga, nearBySearchSaga, placeDetailsSaga,locationCheckSaga } from "./GoogleMapSaga";
import { cancelReasonSaga, rateCalculationSaga, refundPriceSaga, tripCheckoutSaga, tripSlabSaga, rentalSlabSaga } from "./CustomerTripSaga";


export default function* rootSaga() {
  yield all([
    tripSlabSaga,
    tripCheckoutSaga(),
    rateCalculationSaga(),
    autoCompleteSaga(),
    directionSaga(),
    geocodeSaga(),
    nearBySearchSaga(),
    placeDetailsSaga(),
    locationCheckSaga(),
    loginSaga(),
    otpSaga(),
    vendorSaga(), 
    subVendorSaga(), 
    complianceSaga(), 
    onBoardComplianceSaga(), 
    addVendorSaga(), 
    addSubVendorSaga(), 
    updateVendorSaga(), 
    detailSubVendorSaga(),
    profileSaga(),
    updateProfileSaga(),
    updateSubVendorSaga(),
    driverSaga(),
    updateDriverSaga(),
    addDriverSaga(),
    addOnBoardComplianceSaga(),
    addComplianceSaga(),
    faqSaga(),
    addFaqSaga(),
    updateFaqSaga(),
    deleteFaqSaga(),
    faqSectionSaga(),
    carSaga(),
    addCarSaga(),
    updateCarSaga(),
    deleteCarSaga(),
    facilitiesSaga(),
    tagSaga(),
    addTagSaga(),
    updateTagSaga(),
    ratingSaga(),
    userRideDetailsSaga(),
    userTotalRegistrationSaga(),
    userRideAnalyticSaga(),
    userDailyCustomerSaga(),
    customerSaga(),
    customerComplaintsSaga(),
    configComplianceSaga(),
    moreDriverSaga(),
    matrixDriverSaga(),
    ticketDriverSaga(),
    vehicleSaga(),
    updateVehicleSaga(),
    addVehicleSaga(),
    deleteVehicleSaga(),
    approveComplianceSaga(),
    userOurCarSaga(),
    userCabRideSaga(),
    userTopVendorSaga(),
    userTopSubVendorSaga(),
    userTopDriverSaga(),
    userRideAcceptSaga(),
    userDashboardFeedbackSaga(),
    matrixCustomerSaga(),
    ticketCustomerSaga(),
    tripSaga(),
    notificationSaga(),
    notificationCountSaga(),
    notificationSeenSaga(),
    updateComplianceSaga(),
    requestVehicleSaga(),
    listAssignedVehicleSaga(),
    assignVehicleSaga(),
    updateAssignVehicleSaga(),
    ChooseYourServiceSaga(),
    updateAssignDriverSaga(),
    updateAssignSubVendorSaga(),
    addChooseYourServiceSaga(),
    matrixVehicleSaga(),
    moreVehicleSaga(),
    rateCardSaga(),
    addRateCardSaga(),
    serviceCitySaga(),
    serviceRegionSaga(),
    addServiceRegionSaga(),
    serviceSubVendorRegionSaga(),
    addSubVendorRegionSaga(),
    vendorUserSaga(),
    sosAlertSaga(),
    updateCustomerSaga(),
    updateChooseYourServiceSaga(),
    logoutSaga(),
    cancelTripSaga(),
    assignDriverSaga(),
    bookingSaga(),
    baseFuelSaga(),
    invoiceSaga(),
    invoiceDownloadSaga(),
    customerMatrixSaga(),
    revenueExportSaga(),
    revenueMatrixSaga(),
    revenueSaga(),
    magicTokenSaga(),
    //tokenVerifySaga(),
    getRolesAndPermissionsWatcher(),
    getSupplierRoleWatcher(),
    couponSaga(),
    addCouponSaga(),
    updateCouponSaga(),
    deleteCouponSaga(),
    rideDetailsPolylineSaga(),
    getAvailableSupplierSaga(),
    getAvailablevehicleSaga(),
    allotVehicleSaga(),
    complianceValidationRegexWatcher(),
    rentalSlabSaga()
  ]);
}
